import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Lettres Modernes",
  icon: "📚",
  tagline: "Explorez la littérature française et francophone, développez vos compétences en analyse et écriture",
  duree: "3 à 5 ans",
  diplome: "Licence",
  mode: "Présentiel",
  nombreDebouches: "8",
  description: "La filière Lettres Modernes offre une formation complète en littérature française et francophone, linguistique et écriture créative. Notre programme développe l'esprit critique, les compétences rédactionnelles et la culture littéraire.",
  objectifs: [
    "Maîtriser l'analyse littéraire et textuelle",
    "Développer des compétences rédactionnelles avancées",
    "Acquérir une culture littéraire approfondie",
    "Comprendre les courants littéraires et critiques",
    "Préparer aux concours d'enseignement"
  ],
  programme: [
    { titre: "Licence 1 & 2", matieres: ["Littérature française (Moyen Âge à XXe siècle)", "Linguistique française", "Grammaire et stylistique", "Méthodologie littéraire", "Littérature comparée", "Latin ou grec ancien"] },
    { titre: "Licence 3", matieres: ["Littérature contemporaine", "Littérature francophone", "Théories littéraires", "Écriture créative", "Sémiotique", "Didactique du français"] }
  ],
  debouches: [
    { titre: "Enseignant", description: "Enseignement du français et de la littérature" },
    { titre: "Écrivain", description: "Création littéraire" },
    { titre: "Journaliste", description: "Rédaction et journalisme" },
    { titre: "Éditeur", description: "Édition et publication" },
    { titre: "Correcteur", description: "Relecture et correction" },
    { titre: "Médiateur culturel", description: "Animation culturelle" }
  ],
  competences: ["Maîtrise de l'analyse littéraire", "Compétences rédactionnelles exceptionnelles", "Culture littéraire et artistique vaste", "Esprit critique et capacité d'argumentation", "Maîtrise parfaite de la langue française"]
};

export default function LettresModernes() {
  return <FiliereTemplate filiere={filiereData} />;
}